import { nextTick, onBeforeUnmount, onMounted, type Ref } from "vue";
import {
  trackBehaviorEvent,
  type BehaviorEvent,
} from "../utils/behaviorAnalytics";

export const useBehaviorVisibility = (
  target: Ref<HTMLElement | null>,
  event: BehaviorEvent,
  dwellMs = 750
) => {
  let observer: IntersectionObserver | null = null;
  let dwellTimer: number | null = null;
  let tracked = false;

  const clearDwellTimer = () => {
    if (dwellTimer === null) return;
    window.clearTimeout(dwellTimer);
    dwellTimer = null;
  };

  onMounted(async () => {
    await nextTick();
    if (!target.value || typeof IntersectionObserver === "undefined") return;

    observer = new IntersectionObserver(
      ([entry]) => {
        if (tracked) return;
        if (!entry?.isIntersecting || entry.intersectionRatio < 0.35) {
          clearDwellTimer();
          return;
        }
        if (dwellTimer !== null) return;

        dwellTimer = window.setTimeout(() => {
          dwellTimer = null;
          tracked = true;
          trackBehaviorEvent(event);
          observer?.disconnect();
        }, dwellMs);
      },
      { threshold: [0, 0.35, 0.6] }
    );
    observer.observe(target.value);
  });

  onBeforeUnmount(() => {
    clearDwellTimer();
    observer?.disconnect();
  });
};
